<template>
  <div>
    <vs-card v-if="trip" class="cardx">
      <div
        slot="header"
        style="
          padding: 10px;
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
        "
      >
        <feather-icon
          @click="$router.go(-1)"
          icon="ArrowLeftIcon"
          class="cursor-pointer navbar-fuzzy-search mr-4"
        />
        <h3>
          <vs-chip transparent :color="getChipColor(trip.status)" class="mr-2">
            {{ trip.status }}
          </vs-chip>
          {{ trip.route.name }} - ({{ trip.hour_start }} - {{ trip.hour_end }})
        </h3>
      </div>

      <div class="">
        <vs-tabs v-model="currentTab">
          <vs-tab label="General">
            <vs-row>
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                <div class="general-data">
                  <div style="padding-right: 10px">
                    <vs-table stripe :data="generalData">
                      <vs-tr
                        :key="`dat-${index}`"
                        v-for="(item, index) in generalData"
                      >
                        <vs-td
                          ><b>{{ item.text }}</b
                          >:</vs-td
                        >
                        <vs-td>{{ item.value }}</vs-td>
                      </vs-tr>
                    </vs-table>
                  </div>
                  <div style="padding-right: 10px">
                    <vs-table class="mt-3" stripe :data="trip_stations">
                      <template slot="thead">
                        <vs-th sort-key="station">Station</vs-th>
                        <vs-th>Status</vs-th>
                        <vs-th>Arrival</vs-th>
                        <vs-th>Departure</vs-th>
                        <vs-th class="passenger-col">Passengers</vs-th>
                      </template>
                      <vs-tr
                        :key="station.station_id"
                        v-for="(station, index) in stations"
                      >
                        <vs-td>
                          <span
                            class="bg-primary"
                            style="width: 5px; height: 5px"
                          ></span>
                          <div
                            class="cursor-pointer"
                            @click="toggleInfoWindow(station, index)"
                          >
                            {{ station.station.name }}
                          </div>
                        </vs-td>
                        <vs-td>
                          <vs-chip
                            transparent
                            :color="getChipColor(station.status)"
                            >{{ station.status }}</vs-chip
                          >
                        </vs-td>
                        <vs-td class="pr-2">
                          <div>{{ station.arrival }}</div>
                        </vs-td>
                        <vs-td class="pr-2">
                          <div>{{ station.departure }}</div>
                        </vs-td>
                        <vs-td class="passenger-col">
                          <feather-icon
                            icon="ArrowUpIcon"
                            class=""
                            svg-classes="icon-st text-success"
                          />
                          {{ station.users.pickup }}

                          <feather-icon
                            icon="ArrowDownIcon"
                            class="ml-2"
                            svg-classes="icon-st text-danger"
                          />
                          {{ station.users.dropoff }}
                        </vs-td>
                      </vs-tr>
                    </vs-table>
                  </div>
                </div>
              </vs-col>
              <vs-col vs-lg="7" vs-sm="7" vs-xs="12">
                <LMap
                  ref="mapRef"
                  :zoom="8"
                  :center="[center.lat, center.lng]"
                  style="height: calc(100vh - 308px); width: 100%"
                >
                  <LTileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                  />

                  <!-- Marcadores de las estaciones -->
                  <LMarker
                    v-if="location && trip.status !== 'completed'"
                    :lat-lng="location"
                    :icon="busStationIcon"
                  >
                    <LPopup>Current Location</LPopup>
                  </LMarker>

                  <!-- Marcadores de estaciones -->
                  <LMarker
                    v-for="(station, index) in trip.stations"
                    :key="index"
                    :lat-lng="[
                      station.station.latitude,
                      station.station.longitude,
                    ]"
                    :icon="dotIcon"
                    @click="toggleInfoWindow(station, index)"
                  >
                    <LPopup>
                      <div>
                        <strong>{{ station.station.name }}</strong
                        ><br />
                        Arrival: {{ station.arrival }}<br />
                        Departure: {{ station.departure }}<br />
                        Status: {{ station.status }}
                      </div>
                    </LPopup>
                  </LMarker>

                  <!-- Ruta entre estaciones -->
                  <LPolyline :lat-lngs="routePath" :color="'blue'" />
                </LMap>
              </vs-col>
            </vs-row>
          </vs-tab>

          <vs-tab label="Passengers">
            <orders type="trip" :filters="{ trip_id: $route.params.trip_id }" />
          </vs-tab>
          <vs-tab label="Settings">
            <div>
              <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-2 mt-3">
                  <label class="vs-input--label" style="display: block"
                    >Date</label
                  >
                  <flat-pickr
                    :disabled="trip.status === 'completed'"
                    class="w-full flatpickr-input"
                    :config="{}"
                    v-model="form_general.date"
                    placeholder="Date"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2 mt-3">
                  <label class="vs-input--label">Driver</label>
                  <v-select
                    :clearable="false"
                    :disabled="trip.status === 'completed'"
                    v-model="form_general.driver_id"
                    v-validate="'required'"
                    name="driver_id"
                    data-vv-as="driver"
                    :class="errors.has('driver_id') ? 'danger' : ''"
                    :options="drivers"
                    :reduce="(el) => el.id"
                    :get-option-label="
                      (option) => {
                        return `${option.firstname} ${option.lastname}`;
                      }
                    "
                    label="firstname"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2 mt-3">
                  <label class="vs-input--label">Vehicle</label>
                  <v-select
                    :clearable="false"
                    :disabled="trip.status === 'completed'"
                    v-model="form_general.vehicle_id"
                    v-validate="'required'"
                    name="vehicle_id"
                    data-vv-as="vehicle"
                    :class="errors.has('vehicle_id') ? 'danger' : ''"
                    :options="vehicles"
                    :reduce="(el) => el.id"
                    label="nicename"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2 mt-3">
                  <vs-input
                    :disabled="trip.status === 'completed'"
                    type="number"
                    label="Seats"
                    name="seats"
                    v-validate="'required'"
                    :danger="errors.has('seats')"
                    :danger-text="
                      errors.has('seats') ? errors.first('seats') : null
                    "
                    v-model="form_general.seats"
                    class="w-full"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2 mt-3">
                  <vs-input
                    :disabled="trip.status === 'completed'"
                    type="number"
                    label="Price"
                    name="price"
                    v-validate="'required'"
                    :danger="errors.has('price')"
                    :danger-text="
                      errors.has('price') ? errors.first('price') : null
                    "
                    v-model="form_general.price"
                    class="w-full"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2 mt-3">
                  <vs-input
                    :disabled="trip.status === 'completed'"
                    type="text"
                    label="Trip code"
                    name="code"
                    v-validate="''"
                    :danger="errors.has('code')"
                    :danger-text="
                      errors.has('code') ? errors.first('code') : null
                    "
                    v-model="form_general.code"
                    class="w-full"
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-2 mt-3">
                  <vs-checkbox
                    :disabled="trip.status === 'completed'"
                    v-model="form_general.is_active"
                    >Enabled</vs-checkbox
                  >
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col sm:w-2/3 mb-2 mt-3">
                  <vs-button
                    class="mr-3"
                    v-if="trip.status === 'processing'"
                    color="danger"
                    @click="endTrip"
                    >End trip</vs-button
                  >
                  <vs-button
                    class="mr-3"
                    color="primary"
                    @click="resetDefault"
                    :disabled="isFormEqual || trip.status === 'completed'"
                    >Reset</vs-button
                  >
                  <vs-button
                    class="mr-3"
                    color="danger"
                    @click="saveTrip"
                    :disabled="isFormEqual || trip.status === 'completed'"
                    >Save</vs-button
                  >
                </div>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Stations">
            <div slot="header" style="padding: 10px">
              <h3>Stations</h3>
            </div>
            <div>
              <form @submit.prevent="" data-vv-scope="stations">
                <vs-table stripe :data="stations">
                  <template slot="thead">
                    <vs-th sort-key="station"> Station </vs-th>
                    <vs-th style="width: 100px"> Type </vs-th>
                    <vs-th style="width: 200px"> Arrival </vs-th>
                    <vs-th style="width: 200px"> Departure </vs-th>
                    <vs-th style="width: 50px"> Action </vs-th>
                  </template>
                  <vs-tr
                    :key="station.station_id"
                    v-for="(station, index) in stations"
                  >
                    <vs-td>
                      {{ station.station.name }}
                    </vs-td>
                    <vs-td>
                      {{ station.type }}
                    </vs-td>
                    <vs-td class="pr-2">
                      <flat-pickr
                        :disabled="trip.status === 'completed'"
                        :config="configdateTimePicker"
                        v-model="station.arrival"
                        v-validate="
                          'required' +
                          (index < stations.length && index > 0
                            ? stations[index - 1].departure && station.departure
                              ? `|time_between:${
                                  stations[index - 1].departure
                                },${station.departure}`
                              : ''
                            : station.departure
                            ? `|time_lt:${station.departure}`
                            : '')
                        "
                        :name="'arrival' + index"
                        data-vv-as="arrival"
                        :class="
                          errors.has('stations.arrival' + index)
                            ? 'flatpickr-input border-danger w-full'
                            : 'flatpickr-input w-full'
                        "
                        placeholder="Arrival"
                      />
                      <span
                        ><div
                          class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
                          style=""
                        >
                          <span class="span-text-validation">{{
                            errors.first("stations.arrival" + index)
                          }}</span>
                        </div>
                      </span>
                    </vs-td>
                    <vs-td class="pr-2">
                      <flat-pickr
                        :disabled="trip.status === 'completed'"
                        :config="configdateTimePicker"
                        v-model="station.departure"
                        v-validate="
                          'required' +
                          (station.arrival ? `|time_gt:${station.arrival}` : '')
                        "
                        :name="'departure' + index"
                        data-vv-as="departure"
                        :class="
                          errors.has('stations.departure' + index)
                            ? 'flatpickr-input border-danger w-full'
                            : 'flatpickr-input  w-full'
                        "
                        placeholder="Departure"
                      />
                      <span
                        ><div
                          class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
                          style=""
                        >
                          <span class="span-text-validation">{{
                            errors.first("stations.departure" + index)
                          }}</span>
                        </div>
                      </span>
                    </vs-td>
                    <vs-td>
                      <feather-icon
                        v-if="trip.status !== 'completed'"
                        icon="Trash2Icon"
                        @click="removeStation(station.station.id)"
                        class="cursor-pointer navbar-fuzzy-search mr-4"
                      />
                    </vs-td>
                  </vs-tr>
                </vs-table>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/3 w-full mb-2 mt-3">
                    <vs-button
                      class="mr-3"
                      color="primary"
                      @click="resetStations"
                      :disabled="isStationEqual || trip.status === 'completed'"
                      >Reset</vs-button
                    >
                    <vs-button
                      class="mr-3"
                      color="danger"
                      @click="saveStations"
                      :disabled="isStationEqual || trip.status === 'completed'"
                      >Save</vs-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </vs-tab>

          <vs-tab label="Code">
            <vs-row>
              <vs-col>
                <div class="general-data">
                  <div style="padding-right: 10px">
                    <vs-table
                      class="mt-3"
                      stripe
                      max-items="8"
                      search
                      :data="checkins.checkins"
                    >
                      <template slot="thead">
                        <vs-th sort-key="code">Code</vs-th>
                        <vs-th sort-key="success">Status</vs-th>
                        <vs-th sort-key="message">Reason</vs-th>
                        <vs-th sort-key="created_at">Date/Hour</vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td :data="data[indextr].code">
                            {{ data[indextr].code }}
                          </vs-td>

                          <vs-td :data="data[indextr].success">
                            <vs-chip
                              transparent
                              :color="getChipStatus(data[indextr].success)"
                              >{{
                                data[indextr].success ? "Accepted" : "Denied"
                              }}</vs-chip
                            >
                          </vs-td>

                          <vs-td :data="data[indextr].message">
                            {{ data[indextr].message }}
                          </vs-td>

                          <vs-td :data="data[indextr].created_at">
                            {{ funcmoment(data[indextr].created_at) }}
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>

                    <div class="mt-3 mb-3" v-if="page">
                      <pagination
                        :last-page="checkins.pagination.pages"
                        v-model="page"
                      />
                    </div>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </vs-tab>
        </vs-tabs>
      </div>
    </vs-card>
  </div>
</template>
<style>
.map {
  height: calc(100vh - 308px);
  width: 100%;
}
.general-data {
  height: calc(100vh - 308px);
  width: 100%;
  overflow-y: scroll;
}
.icon-st {
  height: 18px;
}
.passenger-col {
  min-width: 120px;
  vertical-align: middle;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { STATION_TYPE } from "../../../constants/routes";
import { orderFn } from "../../../utils/sort";
import Orders from "../../orders/data";
import io from "socket.io-client";
import axios from "axios";
import mapStyle from "../../../constants/mapStyle";
import moment from "moment";
import { LMap, LTileLayer, LMarker, LPolyline, LPopup } from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
export default {
  name: "Details",
  components: {
    flatPickr,
    orders: Orders,
    LMap,
    LTileLayer,
    LMarker,
    LPolyline,
    LPopup,
  },
  data() {
    return {
      dotIcon: L.icon({
        iconUrl: "/img/dot-marker.png",
        iconSize: [22, 22],
        iconAnchor: [11, 11],
      }),
      busStationIcon: L.icon({
        iconUrl: "/img/bus2.png",
        iconSize: [22, 22],
        iconAnchor: [11, 11],
      }),
      trip_path: [],
      currentTab: 0,
      detail: null,
      form_general: {},
      form_backup: {},

      page: null,
      checkins: {
        checkins: [],
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
          pages: 0,
          prev: null,
          next: null,
        },
      },
      stations: [],
      trip_stations: [],
      search: "",
      newDriver: null,
      newVehicle: null,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        time_24hr: true,
      },
      drivers: [],
      vehicles: [],
      station_types: STATION_TYPE,
      orders: {
        orders: [],
      },
      map: null,
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        styles: mapStyle,
      },
      center: { lat: 19.41266, lng: -99.141134 },
      socket: null,
      socket2: null,
      location: null,
      dot_icon: null,
      bus_station_icon: null,
      route: null,
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -5,
        },
      },
      tripPathOptions: {
        strokeColor: "#BDDC04",
        strokeOpacity: 1.0,
        strokeWeight: 4,
      },
    };
  },
  watch: {
    page(newVal, oldVal) {
      if (newVal !== oldVal) {
        let payload_checkins = {
          trip_id: this.$route.params.trip_id,
          page: newVal,
          limit: 20,
        };
        this.getCheckins(payload_checkins)
          .then((data) => {
            this.checkins = data;
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Something went wrong with get checkins",
            });
          });
        // this.getItems(this.search);
      }
    },
    currentTab(newVal, oldVal) {
      if (newVal === 0) {
        this.setMapRef();
      }
    },
  },
  computed: {
    ...mapGetters("users", ["userCan"]),
    ...mapGetters("trips", ["trip"]),
    isFormEqual() {
      return _.isEqual(this.form_backup, this.form_general);
    },
    isStationEqual() {
      return _.isEqual(this.trip_stations, this.stations);
    },
    generalData() {
      var targetreturn = [];
      this.trip
        ? this.trip.driver_replacement != null
          ? (targetreturn = [
              { text: "Date", value: this.trip.date },
              { text: "Zone", value: this.trip.route.zone.name },
              {
                text: "Driver",
                value: `${this.trip.driver.firstname} ${this.trip.driver.lastname}`,
              },
              {
                text: "Driver Replacement",
                value: `${this.trip.driver_replacement.firstname} ${this.trip.driver_replacement.lastname} - ${this.trip.driver_replacement.partner.name}`,
              },
              {
                text: "Vehicle",
                value: `${this.trip.vehicle.model} (${this.trip.vehicle.eco_number})`,
              },
              { text: "Seats", value: this.trip.seats },
              { text: "Bookings", value: this.trip.bookings },
              { text: "Price", value: this.trip.price },
              { text: "Trip code", value: this.trip.trip_code },
              {
                text: "Synced at",
                value: this.funcmoment(this.trip.synced_at),
              },
            ])
          : (targetreturn = [
              { text: "Date", value: this.trip.date },
              { text: "Zone", value: this.trip.route.zone.name },
              {
                text: "Driver",
                value: `${this.trip.driver.firstname} ${this.trip.driver.lastname}`,
              },
              {
                text: "Vehicle",
                value: `${this.trip.vehicle.model} (${this.trip.vehicle.eco_number})`,
              },
              { text: "Seats", value: this.trip.seats },
              { text: "Bookings", value: this.trip.bookings },
              { text: "Price", value: this.trip.price },
              { text: "Trip code", value: this.trip.trip_code },
              {
                text: "Synced at",
                value: this.funcmoment(this.trip.synced_at),
              },
            ])
        : (targetreturn = []);
      return targetreturn;
    },
    routePath() {
      return this.route
        ? this.route.path.map((item) => [item[0], item[1]])
        : [];
    },
    tripPath() {
      // Define el trayecto del vehículo (si es en tiempo real)
      return this.trip_path.map((item) => [item.lat, item.lng]);
    },
  },
  created() {
    this.page = 1;
    this.getItem();
  },
  mounted() {
    setTimeout(() => {
      this.googleloaded();
    }, 1000);
    this.$nextTick(() => {
      this.fitStations();
    });
  },
  beforeDestroy() {
    console.log("beforeDestroy");
  },
  destroyed() {
    console.log("destroyed");
  },
  methods: {
    ...mapActions("trips", [
      "getTrip",
      "updateTrip",
      "updateStations",
      "deleteStation",
      "getOrders",
      "finishTrip",
      "getCheckins",
    ]),
    ...mapActions("drivers", ["fetchDrivers"]),
    ...mapActions("vehicles", ["fetchVehicles"]),
    ...mapActions("routes", ["getRoute"]),
    getItem() {
      this.$vs.loading({ type: "point" });
      this.getTrip({ id: this.$route.params.trip_id })
        .then((data) => {
          setTimeout(() => {
            this.$vs.loading.close();
          }, 1000);
          let getData = !this.detail;
          this.detail = _.cloneDeep(data);
          this.form_general = {
            id: this.$route.params.trip_id,
            partner_id: this.detail.partner.id,
            driver_id: this.detail.driver.id,
            vehicle_id: this.detail.vehicle.id,
            seats: this.detail.seats,
            price: this.detail.price,
            date: this.detail.date,
            is_active: this.detail.is_active,
            code: this.detail.code,
            synced_at: this.detail.synced_at,
          };
          this.form_backup = _.cloneDeep(this.form_general);
          let stations = _.cloneDeep(data.stations);
          this.stations = _.cloneDeep(stations.sort(orderFn));
          this.trip_stations = _.cloneDeep(this.stations);
          this.checkins.checkins = [
            {
              code: "",
              status: true,
              message: "",
              created_at: "2021-04-15 01:02:03",
            },
          ];
          if (this.page > 1 && this.page > this.checkins.pagination.pages) {
            this.page = this.checkins.pagination.pages;
          }
          let payload_checkins = {
            trip_id: this.$route.params.trip_id,
            page: this.page,
            limit: 20,
          };
          this.getCheckins(payload_checkins)
            .then((data) => {
              this.checkins = data;
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Something went wrong with get checkins",
              });
            });
          if (getData) {
            this.fetchPartnerData();
            this.fetchRoute();
            if (data.status === "completed" || data.status === "processing") {
              //this.getTripPath();
            }
            setTimeout(() => {
              this.setMapRef();
              this.tracking();
            }, 500);
          }
        })
        .catch((error) => {
          setTimeout(() => {
            this.$vs.loading.close();
          }, 1000);
        });
    },
    funcmoment(_time) {
      return moment(_time).format("DD-MM-YYYY HH:mm");
    },
    fetchRoute() {
      this.getRoute({ id: this.trip.route_id })
        .then((data) => {
          this.route = _.cloneDeep(data);
        })
        .catch((error) => {});
    },
    fetchPartnerData() {
      this.fetchDrivers({
        page: 1,
        limit: 1000,
        partner_id: this.detail.partner.id,
      })
        .then((data) => {
          this.drivers = data.drivers;
        })
        .catch((error) => {});
      this.fetchVehicles({
        page: 1,
        limit: 100000,
        partner_id: this.detail.partner.id,
      })
        .then((data) => {
          this.vehicles = data.vehicles.map((item) => ({
            ...item,
            nicename: `${
              item.eco_number
                ? `${item.plate} (${item.eco_number})`
                : item.plate
            } - ${item.seats} seats`,
          }));
        })
        .catch((error) => {});
    },
    resetDefault() {
      this.form_general = _.cloneDeep(this.form_backup);
    },
    async saveTrip() {
      if (!this.userCan("trips.update")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }
      let valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }
      if (this.onSubmit === true) return;
      this.onSubmit = true;
      this.updateTrip(_.cloneDeep(this.form_general))
        .then((data) => {
          this.getItem();
          this.onSubmit = false;
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Trip successfully updated",
          });
        })
        .catch((error) => {
          this.onSubmit = false;
          if (error) {
            if (error.status === 409 || error.status === 400) {
              this.setErrors(error.data.errors);
            } else {
              this.$vs.notify({
                color: "danger",
                title: `Error`,
                text: "There was an error. Please try again later.",
              });
            }
          }
        });
    },
    resetStations() {
      this.stations = _.cloneDeep(this.trip_stations);
    },
    async saveStations() {
      let result = await this.$validator.validateAll("stations");
      if (!result) {
        return;
      }
      if (!this.userCan("trips.update")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }
      let payload = {
        id: this.$route.params.trip_id,
        stations: this.stations.map((item) => ({
          station_id: item.station.id,
          order: item.order,
          type: item.type,
          arrival: item.arrival,
          departure: item.departure,
        })),
      };
      this.updateStations(payload)
        .then((data) => {
          this.getItem();
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Updated successfully",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Something went wrong",
          });
        });
    },
    removeStation(station_id) {
      if (!this.userCan("trips.update")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this station?\n This cannot be undone!",
        accept: () => {
          let payload = {
            id: this.$route.params.trip_id,
            station_id,
          };
          this.deleteStation(payload)
            .then((data) => {
              this.getItem();
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "Updated successfully",
              });
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Something went wrong",
              });
            });
        },
      });
    },
    endTrip() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Complete trip `,
        text: "Are you sure you want to execute this action?\n This cannot be undone!",
        accept: () => {
          this.finishTrip({ id: this.$route.params.trip_id })
            .then((data) => {
              this.getItem();
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "The trip  was successfully completed",
              });
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Something went wrong. Try later",
              });
            });
        },
      });
    },
    setErrors(errors) {
      for (let key in errors) {
        if (Array.isArray(errors[key])) {
          this.errors.add({
            field: key,
            msg: errors[key][0],
          });
        }
      }
    },

    getChipStatus(status) {
      if (status === false) {
        return "warning";
      } else if (status === true) {
        return "success";
      } else {
        return "success";
      }
    },
    getChipColor(status) {
      if (status === "pending") {
        return "warning";
      } else if (status === "processing") {
        return "danger";
      } else if (status === "completed") {
        return "success";
      } else if (status === "Aceptado") {
        return "success";
      } else if (status === "Negado") {
        return "danger";
      } else {
        return "success";
      }
    },
    getTripPath() {
      axios
        .get(
          `http://localhost:3000/api/v1/trips/${this.$route.params.trip_id}/path`
        )
        .then((response) => {
          let path = [];
          for (let item of response.data) {
            path.push({ lat: item.latitude, lng: item.longitude });
          }
          this.trip_path = path;
        })
        .catch((error) => {});
    },
    googleloaded() {
      if (typeof google === "object" && typeof google.maps === "object") {
        this.bus_station_icon = {
          url: "/img/dot-marker.png",
          scaledSize: new google.maps.Size(22, 22),
          anchor: new google.maps.Point(11, 11),
        };
      } else {
        setTimeout(() => {
          this.googleloaded();
        }, 1000);
      }
    },
    tracking() {
      this.dot_icon = {
        url: "/img/bus2.png",
        scaledSize: new google.maps.Size(22, 22),
        anchor: new google.maps.Point(11, 11),
      };
      if (this.trip.status === "processing") {
        const trip_id = `trip_${this.$route.params.trip_id}`;
      }
    },
    setMapRef() {
      if (this.$refs.mapRef) {
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.map = map;
          this.fitStations();
        });
      } else {
        setTimeout(() => {
          this.setMapRef();
        }, 100);
      }
    },
    fitStations() {
      if (this.trip && this.trip.stations.length > 0) {
        const bounds = L.latLngBounds(
          this.trip.stations.map((station) => [
            station.station.latitude,
            station.station.longitude,
          ])
        );
        if (this.$refs.mapRef) {
          this.$refs.mapRef.mapObject.fitBounds(bounds); // Ajusta el mapa a los límites
        }
      }
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = {
        lat: marker.station.latitude,
        lng: marker.station.longitude,
      };
      this.infoContent = this.getInfoWindowContent(marker);
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getInfoWindowContent: function (marker) {
      return `<div class="card">
    <div class="card-image">
      <figure class="image is-4by3">
        ${
          marker.station.image
            ? `<img style="width: 200px;" src="${marker.station.image}" alt="Placeholder image">`
            : ""
        }
      </figure>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title is-4"><b>${marker.station.name}</b></p>
        </div>
      </div>
      <div class="content">
        ${marker.station.description}
        <br>
        <b>Arrival</b>: ${marker.arrival}
        <br/>
        <b>Departure</b>: ${marker.departure}
       <br/>
       <b>Status: </b> ${marker.status}
      </div>
    </div>
  </div>`;
    },
  },
};
</script>
